import { RoutingService, GlobalMessageService, GlobalMessageType, OccEndpointsService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { KnBrEditOrderRequest, KnBrEditOrderRequestEntryInput, KnBrAddRequestEntry } from './../../../models/kn-br-order.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrOrderHistoryService } from './../../../store/kn-br-order-history/kn-br-order-history.service';
import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { OrderDetailsService } from '@spartacus/order/components';
// import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { KnBrQuotesService } from 'src/app/store/kn-br-quotes/kn-br-quotes.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { HttpClient } from '@angular/common/http';
import { KN_BR_CUSTOMER_CURRENT, KNBR_GET_INFO_TO_CREATE_CASE } from 'src/constants/api.endpoints.constant';
import { ViewportScroller, NgClass, AsyncPipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { RouterLink } from '@angular/router';
import { MediaComponent } from '@spartacus/storefront';
import { NgbTooltip, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody } from '@ng-bootstrap/ng-bootstrap';
import { KnBrEditOrderItemComponent } from './kn-br-edit-order-item/kn-br-edit-order-item.component';
import { KnBrAddProductsComponent } from '../kn-br-add-products/kn-br-add-products.component';

@Component({
    selector: 'knbr-kn-br-order-details-items',
    templateUrl: './kn-br-order-details-items.component.html',
    styleUrls: ['./kn-br-order-details-items.component.scss'],
    imports: [ReactiveFormsModule, NgSelectComponent, NgClass, RouterLink, MediaComponent, NgbTooltip, KnBrEditOrderItemComponent, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody, KnBrAddProductsComponent, AsyncPipe, UrlPipe, TranslatePipe]
})
export class KnBrOrderDetailsItemsComponent implements OnInit, OnDestroy {
  order$: Observable<any>;
  subscription = new Subscription();
  isOrderEditable$: Observable<boolean> = this.knBrOrderHistoryService.isEditOrderable$();
  editItems: KnBrEditOrderRequestEntryInput[] = [];
  addedProductItems: KnBrAddRequestEntry[] = [];
  editRequest: KnBrEditOrderRequest;
  subscrption = new Subscription();
  detailsForm: UntypedFormGroup;
  lineItemstatuses;
  orderCode: string;
  priceUnit: any;
  show = true;
  @Input()
  index: any = 0;
  inlineOrders = [];
  createCasetoolTipText = `If you need assistance with this product,please click 'Submit Case'`;
  customerId: any;
  ViewportScroller = inject(ViewportScroller);

  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected knBrOrderHistoryService: KnBrOrderHistoryService,
    protected knBrCommonService: KnBrCommonService,
    protected routingService: RoutingService,
    protected messageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected knBrQuoteService: KnBrQuotesService,
    protected endPointService: OccEndpointsService,
    protected http: HttpClient,
    protected knBrCustomerContextService: KnBrCustomerContextService,
  ) {
    this.routingService
      .getRouterState()
      .subscribe((state) => {
        const url = state?.state?.url;
        if (url?.includes('order/')) {
          const segments = url.split('/');
          const orderIndex = segments.findIndex(segment => segment === 'order');
          if (orderIndex !== -1 && orderIndex < segments.length - 1) {
            this.orderCode = segments[orderIndex + 1];
            this.editRequest = {
              orderCode: this.orderCode,
              editOrderRequest: {
                editRequestEntryInputs: this.editItems,
                addRequestEntryInputs: this.addedProductItems,
              },
            };
          }
        }
        // if (state && state.state && state.state.params && state.state.params.orderCode) {
        //   this.orderCode = state.state.params.orderCode;
        //   this.editRequest = {
        //     orderCode: this.orderCode,
        //     editOrderRequest: {
        //       editRequestEntryInputs: this.editItems,
        //       addRequestEntryInputs: this.addedProductItems,
        //     },
        //   };
        // }
      })
      .unsubscribe();
    this.subscription.add(
      this.knBrOrderHistoryService.loadSaveEditOrderRequest$().subscribe((saveRequest) => {
        if (saveRequest) {
          if (this.editRequest && this.editRequest.orderCode) {
            const canEditOrder = this.editRequest.editOrderRequest.editRequestEntryInputs
              .filter((editItem) => editItem.quantity === 0 && !editItem.cancelReason)
              .map((item) => item.orderEntryNumber)
              .join(',');
            if (canEditOrder) {
              this.messageService.add(
                { key: 'knbrOrderDetails.editOrder.cancelSelectWarning' },
                GlobalMessageType.MSG_TYPE_WARNING
              );
            } else {
              this.knBrOrderHistoryService.editOrder(this.editRequest);
            }
          }
        }
      })
    );
  }

  ngOnInit(): void {
    this.order$ = this.orderDetailsService.getOrderDetails();
    this.knBrCommonService.getCancelOrderStatusList();
    this.detailsForm = this.fb.group({ statusFilter: null });
    this.ViewportScroller.scrollToPosition([0, 0])

    this.subscription.add(
      this.order$.subscribe((res: any) => {
        if (res.orderEntries && res.orderEntries.length > 0) {
          this.inlineOrders = res.orderEntries;
          const options = [];
          options.push({"Key": 20, "Text": 'All' });
          Object.keys(res.orderEntries).forEach((key) => {
            if (res.orderEntries[key].lineItemStatus !== undefined && res.orderEntries[key].lineItemStatus !== 'Rejected') {
              options.push({"Key": key, "Text": res.orderEntries[key].lineItemStatus });
            }
          });
          res.orderEntries.find(item => {
            if (item.lineItemStatus === undefined) {
              options.push({"Key": 9, "Text": 'None' });
            }
          });
          this.lineItemstatuses = _.uniqBy(options, 'Text');
        }
      })
    );
    this.subscription.add(this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
    }))
  }

  statusChange(event) {
    this.order$.subscribe(res => {
      if (event.Text === 'All') {
        this.inlineOrders = res.orderEntries;
      } else if (event.Text === 'None') {
        this.inlineOrders = res.orderEntries.filter(item => item.lineItemStatus === undefined);
      } else {
        this.inlineOrders = res.orderEntries.filter(item => item.lineItemStatus === event.Text);
      }
    })
  }

   getProductRouteParams(product: any) {
    if (!product) {
      return product;
    }

    const productCode = product.baseProduct || product.code;
    return {
      ...product,
      code: productCode,
    };
  }

  getProductQueryParams(product: any) {
  return product?.code ? { genericVariantProduct: product.code } : null;
}

  getPriceUnit(type: string, item:any) {
    return (type === 'ZTD' || type === 'ZQTD') ? '-' : `${item?.knbrTotalPrice?.formatedNetPrice} ${item?.knbrTotalPrice?.conditionUnit}`;
  }

  onQuantityChange(eventData) {
    const index = _.findIndex(this.editItems, { orderEntryNumber: eventData.orderEntryNumber });

    // Replace item at index using native splice
    if (index >= 0) {
      this.editItems[index] = eventData;
    } else {
      this.editItems.push(eventData);
    }
    this.editRequest = {
      orderCode: this.orderCode,
      editOrderRequest: {
        editRequestEntryInputs: this.editItems,
        addRequestEntryInputs: this.addedProductItems,
      },
    };
  }

  onInputChange(eventData) {
    this.addedProductItems = eventData;
    this.editRequest = {
      orderCode: this.orderCode,
      editOrderRequest: {
        editRequestEntryInputs: this.editItems,
        addRequestEntryInputs: this.addedProductItems,
      },
    };
  }

  goBack() {
    this.routingService.go({ cxRoute: 'orders' }, { state: { displayPersistedValues: true }});
  }

  // showHide($event: NgbPanelChangeEvent, acc) {
  //   if (!acc.isExpanded($event.panelId)) {
  //     const idx = $event.panelId.slice(-1)
  //     this.show = true;
  //     this.index = idx;
  //   } else {
  //     this.show = false;
  //   }
  // }

  navigateToCaseCreation(materialNumber, entryNumber) {
    const orderNumber = this.orderCode
    const url = this.endPointService.buildUrl(KNBR_GET_INFO_TO_CREATE_CASE(this.customerId), {
      queryParams: {
        orderNumber,
        materialNumber: materialNumber,
        entryNumber:entryNumber
      }
    });
    this.subscription.add(this.http.get(url).subscribe((resp:any)=> {
      if(resp && resp.invoices && resp.invoices.length) {
        const urlValue = `my-account/case-creation?orderNumber=${orderNumber}&materialNumber=${materialNumber}&entryNumber=${entryNumber}`
        this.routingService.goByUrl(urlValue);
      } else {
        this.messageService.add(
          'Case can not be created at this time. Please reach out directly to your Order Management Specialist for assistance.',
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    }))

  }

  navigateToQuote(quoteNum) {
    this.knBrQuoteService.get(quoteNum);
    this.routingService.go({ cxRoute: 'quoteDetails', params: { code: quoteNum } });
  }

  ngOnDestroy() {
    this.knBrOrderHistoryService.setOrderEditable(false);
    this.knBrOrderHistoryService.setSaveEditOrderRequest(false);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
